import { useSelector } from "react-redux";

import { RootState } from "~/state/store";

export default function useUser() {
  return useSelector((state: RootState) => state.user);
}
